import config from "../../config";

const LAST_CAPTURED_AT_KEY = "lastCapturedAt";

export { LAST_CAPTURED_AT_KEY };

export default function isAllowedMarketingParam(
  name,
  marketingParamsConfig = config.marketingParams
) {
  if (!name || !marketingParamsConfig) {
    return false;
  }

  const { allowedNames = [], allowedPrefixes = [] } = marketingParamsConfig;

  if (allowedNames.includes(name)) {
    return true;
  }

  return allowedPrefixes.some(prefix => name.startsWith(prefix));
}
